import axios from 'axios';
import { clearAuthStorage, getAuthToken } from '../utils/authStorage';

// 환경 변수에서 설정 가져오기
const ENV = process.env.REACT_APP_ENV || 'development';
let API_BASE_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:8080';
const WS_URL_ENV = process.env.REACT_APP_WS_URL;

const normalizeSockJsUrl = (url) => {
  if (!url) {
    return url;
  }
  if (url.startsWith('ws://')) {
    return url.replace('ws://', 'http://');
  }
  if (url.startsWith('wss://')) {
    return url.replace('wss://', 'https://');
  }
  return url;
};

let WS_URL = normalizeSockJsUrl(WS_URL_ENV) || `${API_BASE_URL}/ws/chat`;

const isLoopbackHost = (host) => host === 'localhost' || host === '127.0.0.1';
const resolveDevBackendOrigin = (hostname) =>
  isLoopbackHost(hostname) ? 'http://localhost:8080' : `http://${hostname}:8080`;

// 개발 시: CRA(3000) URL 보정, LAN IP 접속 시 localhost:8080 → 같은 호스트:8080
if (typeof window !== 'undefined' && ENV === 'development') {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const backendOrigin = resolveDevBackendOrigin(hostname);

  if (!isLoopbackHost(hostname)) {
    try {
      if (isLoopbackHost(new URL(API_BASE_URL).hostname)) {
        API_BASE_URL = backendOrigin;
      }
    } catch {
      API_BASE_URL = backendOrigin;
    }
    try {
      if (isLoopbackHost(new URL(WS_URL).hostname)) {
        WS_URL = `${backendOrigin}/ws/chat`;
      }
    } catch {
      WS_URL = `${backendOrigin}/ws/chat`;
    }
  }

  if (API_BASE_URL === origin || API_BASE_URL === '' || API_BASE_URL.startsWith('http://localhost:3000')) {
    API_BASE_URL = backendOrigin;
  }
  if (WS_URL.startsWith('http://localhost:3000') || WS_URL === `${origin}/ws/chat`) {
    WS_URL = `${backendOrigin}/ws/chat`;
  }
}

export { WS_URL };

// 개발 모드에서 환경 정보 로깅 (프로덕션에서는 제거됨)
if (ENV === 'development') {
  console.log('환경 설정:', {
    ENV,
    API_BASE_URL,
    WS_URL
  });
}

// axios 기본 설정
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 요청 인터셉터 - JWT 토큰 자동 추가
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 401 발생 시 호출할 핸들러 (App에서 navigate + showAlert 사용 위해 등록)
let unauthorizedHandler = null;
export const setUnauthorizedHandler = (fn) => {
  unauthorizedHandler = fn;
};
const getUnauthorizedHandler = () => unauthorizedHandler;

// 응답 인터셉터 - 토큰 만료 시 로그아웃 후 로그인 페이지로 (React Router + 알림 연동)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      clearAuthStorage();
      const handler = getUnauthorizedHandler();
      if (typeof handler === 'function') {
        handler();
      } else {
        // 앱 마운트 전 401(예: 초기 프로필 조회) 시 폴백
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
